/**
 * Checks if a plan has a zero shipment limit (not unlimited, but limit is 0)
 * This indicates a free plan with no shipments allowed.
 * @param shipmentLimit - The shipment limit object containing isUnlimited and limit properties
 * @returns true if the plan has exactly 0 shipments and is not unlimited
 */
export const hasZeroShipmentLimit = (shipmentLimit?: { isUnlimited?: boolean; limit?: number }): boolean => {
  if (!shipmentLimit) return false;
  return shipmentLimit.limit === 0 && !shipmentLimit.isUnlimited;
};
